import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-medium text-foreground-500 tracking-wider uppercase">About Litbuy</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
            Data-Driven SEO
            <br />
            For Modern Sellers
          </h2>
          <p className="mt-6 md:mt-8 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
            Litbuy Spreadsheet is the go-to resource center for e-commerce entrepreneurs looking to harness the power of organized data. 
            Our comprehensive guides, reviews, and comparison tools help sellers make informed decisions about their spreadsheet management strategy. 
            Whether you are tracking inventory, analyzing sales trends, or planning your next product launch, Litbuy Spreadsheet provides the 
            structured framework you need to succeed in the competitive online marketplace.
          </p>
          <Link
            to="/litbuy-spreadsheet-guide"
            className="whitespace-nowrap cursor-pointer mt-6 md:mt-8 inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors"
          >
            Read Our Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-12 md:mt-16 flex flex-col md:flex-row gap-4 md:gap-6">
          <div className="md:w-2/5 rounded-2xl overflow-hidden aspect-[4/3] md:aspect-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20dual%20monitors%20showing%20colorful%20spreadsheets%20and%20analytics%2C%20surrounded%20by%20design%20books%20and%20a%20ceramic%20coffee%20mug%2C%20warm%20afternoon%20sunlight%20through%20blinds%2C%20creative%20professional%20workspace%20photography&width=800&height=600&seq=about-v3-left&orientation=landscape"
              alt="Litbuy Spreadsheet workspace"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="md:w-3/5 rounded-2xl overflow-hidden aspect-[16/7] md:aspect-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20small%20business%20inventory%20room%20with%20neatly%20labeled%20boxes%20on%20shelves%20and%20a%20tablet%20showing%20inventory%20management%20software%2C%20bright%20LED%20lighting%2C%20efficient%20and%20clean%20warehouse%20organization%2C%20professional%20logistics%20photography&width=1200&height=600&seq=about-v3-right&orientation=landscape"
              alt="Litbuy Spreadsheet inventory management"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}